'use client';

import { useContext } from "react";
import classes from "./public_provider_pagination.module.css";
import FilterContext from "@/providers/filter-context";
import CustomButton from "../common/buttons/button";
import ArrowLeft from '@/assets/svg/icons/arrow-left.svg';
import ArrowRight from '@/assets/svg/icons/arrow-right.svg';
import { usePathname, useSearchParams } from "next/navigation";

export default function PublicProvidersPagination({}) {
    const filters = useContext(FilterContext);
    const pathname = usePathname();
    const searchParams = useSearchParams();

    let pager_diff = 2;

    let prev_button = <></>;
    let next_button = <></>;
    let first_button = <></>;
    let last_button = <></>;

    const buttons = [];

    const act_page = ((searchParams.get("page") && !isNaN(Number(searchParams.get("page")))) ? Number(searchParams.get("page")) : 1);

    if(filters && filters.pager) {
        if((act_page > 2) && (act_page < (filters.pager.page_nums))) pager_diff = 1;

        const params = new URLSearchParams(Array.from(searchParams.entries()));

        params.set("page", ((act_page - 1) > 1 ? (act_page - 1) : 1));
        prev_button = <CustomButton key={`public-provider-pagination-prev`} size="sm" hierarchy={"tertiary-gray"} href={`${pathname}?${params.toString()}`} disabled={act_page === 1} icon="leading" is_svg={true} svg={ArrowLeft} ><p className={`${classes["hide-pagination-text"]}`}>Előző</p></CustomButton>
        params.set("page", 1);
        first_button = <CustomButton key={`public-provider-pagination-1`} size="sm" hierarchy={1 === act_page ? "primary" : "tertiary-gray"} href={`${pathname}?${params.toString()}`} >1</CustomButton>

        for(let i = (((act_page - pager_diff) > 2 ? (act_page - pager_diff) : 2)); i <= (((act_page + (pager_diff + 1)) < filters.pager.page_nums) ? (act_page + (pager_diff + 1)) : filters.pager.page_nums); i++) {
            params.set("page", i);
            buttons.push({id: i, text: i, url: `${pathname}?${params.toString()}`});
        }
        
        params.set("page", filters.pager.page_nums);
        last_button = <CustomButton key={`public-provider-pagination-${filters.pager.page_nums}`} size="sm" hierarchy={filters.pager.page_nums === act_page ? "primary" : "tertiary-gray"} href={`${pathname}?${params.toString()}`} >{filters.pager.page_nums}</CustomButton>
        params.set("page", ((act_page + 1) <= filters.pager.page_nums ? (act_page + 1) : filters.pager.page_nums));
        next_button = <CustomButton key={`public-provider-pagination-next`} size="sm" hierarchy={"tertiary-gray"} href={`${pathname}?${params.toString()}`} disabled={act_page === filters.pager.page_nums || filters.pager.page_nums === 0} icon="trailing" is_svg={true} svg={ArrowRight} ><p className={`${classes["hide-pagination-text"]}`}>Következő</p></CustomButton>
    }

    return <div className={`${classes["public-provider-pagination-container"]}`}>
        {prev_button}
        <div className={`d-flex flex-row align-items-center gap-1 ${classes["pagination-pages"]}`}>
            {first_button}
            {(act_page - pager_diff > 2) && <div>...</div>}
            {buttons.map(b => <CustomButton key={`public-provider-pagination-${b.id}`} size="sm" hierarchy={b.id === act_page ? "primary" : "tertiary-gray"} href={`${b.url}`} >{b.text}</CustomButton>)}
            {filters.pager?.page_nums > 0 && (act_page + pager_diff + 2 < filters.pager.page_nums) && <div>...</div>}
            {(filters.pager?.page_nums > (1 + pager_diff)) && (act_page + pager_diff + 1 < filters.pager.page_nums) && last_button}
        </div>
        {next_button}
    </div>
}